export default function() {
    const self = this,
        id = self.$route.params.id

    if (id) {
        self.load(id)
    }
}
